import type { FaireProductEntity } from "../../entity_types/product";

export const p_vq2n2xbw9d: FaireProductEntity = {
  token: "p_vq2n2xbw9d",
  type: "product",
  name: "Day of the Dead Mariachi Skeleton Building Set",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/33a598b15963100968493be31df198e71fbcc28b30d6647d47214e9b8b087a62.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bec16b790278135ca5cec8f0a93a195b6c4ddcbcc26c6b1bcaf0b0dc790693a.jpeg",
    "https://cdn.faire.com/fastly/3f37c43abada74c6bf225ee5624f677ed8c771f223945bd1419c01badf1da475.jpeg",
    "https://cdn.faire.com/fastly/a0ebfa262716a27efa57b673781a1422637cc215e5da27b032892e0cb78538c9.jpeg",
    "https://cdn.faire.com/fastly/8cf72410c11cb3cbe06833445dfdd3f916c9b6ba673e4f961882f8e9a4de50f6.jpeg",
    "https://cdn.faire.com/fastly/b2e8390467de658fc4f18e4d0d230ebc201d302c5ffd1d6b761fcad14a3501dd.jpeg",
    "https://cdn.faire.com/fastly/89d123b7a28ed432ffa157bafca3aed077f19cc1da1c34f83cf0a756f3032939.jpeg",
    "https://cdn.faire.com/fastly/27742c118eb62f3da91aa17bad1de7e65528964d8a6a94bc6bdc5aec948734ce.jpeg",
  ],
  priceDollars: 13.78,
  description:
    "Celebrate life, music, and tradition with the Brickcraft Day of the Dead Mariachi Building Kit. This fully posable skeleton figure features a bright sombrero, expressive face design, and classic mariachi accessories like a brick-built guitar and maracas. Whether dancing, strumming, or posing proudly, he’s ready to add personality to your display for Día de los Muertos and beyond.",
  tags: [],
  msrpDollars: 27.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:56.417Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
